import request from '@/utils/request'

export async function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data: {
      llid: data.username,
      pswd: data.password,
    },
  })
}

export function getUserInfo(accessToken) {
  // return Promise.resolve({
  //   llid: 'm11',
  //   role: 'a',
  //   abilitys: [{ a: true }, { b: false }],
  // })
  return request({
    url: '/login/userInfo',
    method: 'post',
  })
}
export function logout() {
  return new Promise((resolve) => {
    resolve()
  })
}

export function register(data) {
  return request({
    url: '/reg',
    method: 'post',
    data: {
      llid: data.username,
      code: data.code,
      pswd: data.password,
    },
  })
}

export function retrieveEmail(llid) {
  return request({
    url: '/reg/retrieveEmail',
    method: 'post',
    data: { llid },
  })
}

export function sendEmailCode(llid) {
  return request({
    url: '/reg/code',
    method: 'post',
    data: { llid },
  })
}

export function resetPwd(data) {
  return request({
    url: '/reset',
    method: 'post',
    data: {
      llid: data.username,
      code: data.code,
      pswd: data.password,
    },
  })
}

export function retrieveUserEmail(llid) {
  return request({
    url: '/reset/retrieveEmail',
    method: 'post',
    data: { llid },
  })
}

export function sendResetEmailCode(llid) {
  return request({
    url: '/reset/code',
    method: 'post',
    data: { llid },
  })
}
